import {
	DRAFT_SIGNATURE_IMAGE_ACTION,
	SET_FILE_TIMELINE_CRM_ACTION
} from "../actions/SignatureAction/actionTypes";

const initialState = {
	signatureImageDraft: "",
	urlTimeline: ""
};

const signaturePageReducer = (state = initialState, action) => {
	switch (action.type) {
		case DRAFT_SIGNATURE_IMAGE_ACTION: {
			return {
				...state,
				signatureImageDraft: action.params
			};
		}

		case SET_FILE_TIMELINE_CRM_ACTION: {
			return {
				...state,
				urlTimeline: action.params
			};
		}

		default:
			return state;
	}
};

export default signaturePageReducer;
